import { makeAutoObservable } from 'mobx'
import type { DelayItem } from './Types'

/**
 * Local store of `DelaysSection`.
 * Owns the loaded delays list and loading flag.
 * Instantiated per section mount via `useState(() => new DelaysSectionStore())`.
 */
export class DelaysSectionStore {
    delays: DelayItem[] = []
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    setDelays(items: DelayItem[]): void {
        this.delays = items
    }

    setLoading(v: boolean): void {
        this.loading = v
    }
}
